// // CocaAnnualBase.js - Tab-based COCA Annual System with 3 Tabs
// // Each tab contains different functionality based on requirements
// // Similar structure to ReportsBase.js but specifically for COCA Annual

// import React from 'react';
// import { Tab, Tabs, Box } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { setCocaAnnualTabIndex } from '../../Redux/MNR/CocaAnnualSlice';
// import { isMNR } from '../../Redux/MNR/MNRCommonSlice';
// import CocaAnnualTab from './CocaAnnualTab';

// /**
//  * CocaAnnualBase Component - Tab System for COCA Annual
//  * 
//  * This component provides a 3-tab system where each tab contains:
//  * - COCA-Annual 1: Carrier selection + job start + table (like MMT1)
//  * - COCA-Annual 2: Job start + multiple summary tables for insights
//  * - COCA-Annual 3: Simple job start button only (background job)
//  * 
//  * Each tab operates independently following the Reports pattern
//  */
// const CocaAnnualBase = () => {
//     const dispatch = useDispatch();
//     const cocaAnnualTabIndex = useSelector(state => state.cocaAnnual?.cocaAnnualTabIndex || 0);
//     const mnr = useSelector(state => state.role.mnr);

//     const handleCocaAnnualTabIndexChange = (event, value) => {
//         // Handle hidden tabs - skip them like in Reports
//         if (value < 0 || value >= cocaAnnualTabConfigs.length) {
//             return;
//         }

//         dispatch(setCocaAnnualTabIndex(value));
//         dispatch(isMNR(true));
//     };

//     // Tab configuration following Reports pattern
//     // COCA-Annual 1: Dual table functionality (carrier select + main table + summary)
//     // COCA-Annual 2: Summary tables only with job start
//     // COCA-Annual 3: Job start only (background processing)
//     const cocaAnnualTabConfigs = [
//         { name: 'COCA-Annual 1', mainColumns: 1, secondColumns: 7, type: 'dual-table' },
//         { name: 'COCA-Annual 2', mainColumns: 0, secondColumns: 0, type: 'summary-only' },
//         { name: 'COCA-Annual 3', mainColumns: 0, secondColumns: 0, type: 'job-only' }
//     ];

//     const renderContent = () => {
//         const config = cocaAnnualTabConfigs[cocaAnnualTabIndex];
//         if (!config) return null;

//         return (
//             <CocaAnnualTab
//                 tabIndex={cocaAnnualTabIndex}
//                 tabName={config.name}
//                 mainTableColumns={config.mainColumns}
//                 secondTableColumns={config.secondColumns}
//                 tabType={config.type}
//             />
//         );
//     };

//     const tabStyle = {
//         fontSize: 'var(--font-size-header)',
//         fontFamily: 'var(--font-family-base)',
//         minWidth: '120px',
//         textTransform: 'none'
//     };

//     const tabSxStyle = {
//         color: 'inherit',
//         '&.Mui-selected': {
//             color: 'var(--secondary-color)',
//         },
//     };

//     return (
//         <>
//             <Box display="flex" alignItems="flex-start" sx={{ paddingLeft: '0px', background: 'rgb(251, 249, 244)' }}>
//                 <Tabs
//                     value={cocaAnnualTabIndex}
//                     onChange={handleCocaAnnualTabIndexChange}
//                     variant="scrollable"
//                     scrollButtons="auto"
//                     style={{ paddingLeft: '8px' }}
//                     TabIndicatorProps={{
//                         sx: {
//                             backgroundColor: 'var(--secondary-color)',
//                         },
//                     }}
//                 >
//                     {cocaAnnualTabConfigs.map((config, index) => (
//                         <Tab
//                             key={index}
//                             label={config.name}
//                             style={tabStyle}
//                             sx={tabSxStyle}
//                         />
//                     ))}
//                 </Tabs>
//             </Box>

//             <Box style={{ padding: mnr ? '24px' : '0 0 0 0' }}>
//                 {renderContent()}
//             </Box>
//         </>
//     );
// };

import React, { useEffect } from 'react';
import { Tab, Tabs, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { cocaAnnualTabIndex } from '../../Redux/TabIndexSlice';
import CocaAnnual1 from '../CocaAnnualReports.js/CocaAnnual1';
import CocaAnnual2 from '../CocaAnnualReports.js/CocaAnnual2';
import CocaAnnual3 from '../CocaAnnualReports.js/CocaAnnual3';
import { toast } from 'react-toastify';
import { isCocaAnnual } from '../../Redux/CocaAnnualReports/CocaAnnualCommonSlice';
import { clearCarrierData } from '../../Redux/CocaAnnualReports/CocaCarrierSlice';

function CocaAnnualBase() {
    const dispatch = useDispatch();
    const tab = useSelector(state => state.tab.cocaAnnualTab || 0);
    const reports = useSelector(state => state.role.reports);
    const error = useSelector(state => state.token.error);

    useEffect(() => {
        if (error) {
            toast.error('Token API Error');
        }
    }, [dispatch, error]);

    useEffect(() => {
        dispatch(isCocaAnnual(true));
        //clear datas to be added here
        dispatch(cocaAnnualTabIndex(0));
    }, [dispatch])

    const handleCocaAnnualTabIndexChange = (e, value) => {
        // Clear carrier data when switching tabs
        dispatch(clearCarrierData());
        dispatch(cocaAnnualTabIndex(value));
    }

    const renderContent = () => {
        switch (tab) {
            case 0:
                return <CocaAnnual1 />
            case 1:
                return <CocaAnnual2 />;
            case 2:
                return <CocaAnnual3 />;
            default:
                break;
        }
    }

    return (
        <>
            <Box display="flex" alignItems="flex-start" sx={{ paddingLeft: '0px', background: 'rgb(251, 249, 244)' }}>
                <Tabs
                    value={tab}
                    onChange={handleCocaAnnualTabIndexChange}
                    variant="scrollable"
                    style={{ paddingLeft: '8px' }}
                    TabIndicatorProps={{
                        sx: {
                            backgroundColor: 'var(--secondary-color)',
                        },
                    }}
                >
                    <Tab label="Coca Annual1"
                        style={{
                            fontSize: 'var(--font-size-header)',
                            fontFamily: 'var(--font-family-base)',
                        }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="Coca Annual 2" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="Coca Annual 3" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                </Tabs>
            </Box>
            <Box style={{ padding: reports ? '24px' : '0 0 0 0' }}>
                {renderContent()}
            </Box>
        </>
    )
}

export default CocaAnnualBase;